/// <amd-module name="Build/Designer/Components/ValidationErrors" />
import { Status, StatusSize, Statuses } from "VSSUI/Status";
import { css } from "VSSUI/Util";
import * as React from "react";

export interface ValidationErrorsProps {
    errors: string[];
}

export const ValidationErrors = (props: ValidationErrorsProps): JSX.Element => {
    const { errors } = props;
    return (
        <div className="validation-errors flex-column flex-grow scroll-auto">
            {errors.map((error: string, i: number) => (
                <div
                    className={css(
                        "flex-row flex-center full-width padding-vertical-12 padding-horizontal-12",
                        "separator-line-top",
                        i == errors.length - 1 && "separator-line-bottom"
                    )}
                    tabIndex={i}
                    key={`validation-error-${i}`}
                >
                    <Status {...Statuses.Failed} key={`failed-error-${i}`} size={StatusSize.m} />
                    <p className="word-break padding-left-12">{error}</p>
                </div>
            ))}
        </div>
    );
};
